import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";

import {environment} from "../../../environments/environment";
import {ACTION, ERROR, FORM_EVENT, STATUS} from "../../shared/constant";

@Component({
  selector: 'participation-form-cleanup',
  templateUrl: './participation-form-cleanup.component.html',
  styleUrls: ['./participation-form-cleanup.component.scss']
})

export class ParticipationFormCleanupComponent implements OnInit, OnDestroy {
  formVerCode: string;
  formSubCode: string;
  env: any = environment;
  currentUser: any;
  participationForm$: Observable<any>;
  formStatus: string = FORM_EVENT.LOADING;
  participationFormCode: string;
  participationForm: any;

  constructor(private router: Router, private route: ActivatedRoute, private store: Store<any>) {
    this.participationForm$ = this.store.select('PARTICIPATION_FORM_REDUCER');
  }

  ngOnInit() {
    this.currentUser = this.route.snapshot.data['currentUser'];
    this.participationFormCode = this.route.snapshot.data['participationFormCode'];
    this.participationForm = this.route.snapshot.data['participationForm'];
    this.formSubCode = this.participationForm.formSubmissionCode;
  }

  statusChange(formEvent: any) {
    if (!formEvent)
      this.router.navigate([ERROR.UNKNOWN.url]);

    this.formStatus = formEvent.status;

    switch (formEvent.status) {
      case FORM_EVENT.SUBMITTED : {
        if (!formEvent.submissionCode)
          this.router.navigate([ERROR.UNKNOWN.url]);

        this.handleSubmission(formEvent);
        break;
      }
      case FORM_EVENT.ERROR : {
        this.router.navigate([ERROR.UNKNOWN.url]);
        break;
      }
    }
  }

  handleSubmission(formEvent) {
    this.store.dispatch({
      type: ACTION.PARTICIPATION_FORM_SAVE_CLEANUP,
      payload: {formSubmissionCode: formEvent.submissionCode}
    });
    this.participationForm$
      .filter(state => state.status === STATUS.COMPLETED)
      .first()
      .subscribe(s => {
        if (!s.data.cleanupInProgress)
          this.router.navigate(['participationFormList']);
      });
  }

  ngOnDestroy() {
    this.store.dispatch({
      type: ACTION.PARTICIPATION_FORM_LOAD_CLEANUP,
      payload: {formSubmissionCode: this.formSubCode, cleanupInProgress: false}
    });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/participation-form/participation-form-cleanup/participation-form-cleanup.component.ts